import React, { useState, useEffect } from 'react';
import parse from "html-react-parser";
import Help from "./Help";
////
import axios from 'axios';
////
import tasksJson from "../data/tasksJson.json";
import itemJson from "../data/itemJson.json";
////
import entitlements from "../data/entitlements.js";
import productCodes from "../data/productCodes.js";
////
import { useWindowSize } from '@react-hook/window-size'
////
const GET_INVENTORY_ENTITLEMENTS = process.env.REACT_APP_GET_INVENTORY_ENTITLEMENTS;
const GET_PRODUCTS_LIST = process.env.REACT_APP_GET_PRODUCTS_LIST;
const PURCHASE_PRODUCT_VC = process.env.REACT_APP_PURCHASE_PRODUCT_VC;
const IS_AUTH_USER = process.env.REACT_APP_IS_AUTH_USER;
////

function getCurrentData(data){
    // var offset = +3;
    var months = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
    var d = new Date(); // new Date().getTime() + offset * 3600 * 1000);
    var month = months[d.getUTCMonth()];
    var year = d.getUTCFullYear();

    var newData = month + String(year).slice(2);

    var old = JSON.stringify(data).replace(/#/g, newData);
    return JSON.parse(old);
}

function daysInThisMonth() {
    var now = new Date();
    return new Date(now.getFullYear(), now.getMonth()+1, 0).getDate();
}
            //

const Items = () => {

    const width = useWindowSize()[0];

    const [tasksData, setTasksData] = useState(getCurrentData(tasksJson));

    const [item, setItem] = useState(itemJson);

    const [openPopup, setOpenPopup] = useState(false);

    const [isAuth, setAuth] = useState(false);

    const getProducts = (() => {
        // Заменяем значение в массиве -> tasksData, # -> на месяц + год (newData)
        var newProductCodes = getCurrentData(productCodes);
        axios.post(GET_PRODUCTS_LIST, newProductCodes.data, {
            headers: {
                'Content-Type': 'application/json',
            }
        })
        .then((response) => {

            const responseProducts = response.data.data.items;
            //
            setTasksData(
                tasksData.map((task) => {
                    if (responseProducts.some((product) => product.product_code === task.productCode)) {
                        task.desable = false;
                    }
                    return task;
                })
            );
        });
    });

    const getEntitlements = (() => {
        if ((IS_AUTH_USER === "true") ? true : Boolean(window.is_auth_user())) {
            setAuth(true);
            let newEntitlements = getCurrentData(entitlements);
            axios.post(GET_INVENTORY_ENTITLEMENTS, newEntitlements.data, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
            .then((response) => {
                // Обрезаем массив по количеству дней в месяце
                let _daysInThisMonth = daysInThisMonth();
                tasksData.splice(_daysInThisMonth);

                const responseEntitlements = response.data.data;
                let userEntitlements = {};
                responseEntitlements.map((ent) => userEntitlements[ent.code] = ent.amount);
                setTasksData(
                    tasksData.map((task) => {
                        let claimedRewards = userEntitlements[task.entitlementClaimed] ?? 0;
                        if (claimedRewards + 1 > task.entitlementClaimedCount){
                            task.completed = true;
                        }
                        if (claimedRewards + 1 === task.entitlementClaimedCount &&
                             userEntitlements[task.entitlementDailyClaimed] &&
                             ! userEntitlements[task.entitlementDailyCompleted]){
                            task.completed = true;
                        }
                        return task;
                    })
                );

                getProducts();

            });
        } else {
            setAuth(false)
            // Обрезаем массив по количеству дней в месяце
            let _daysInThisMonth = daysInThisMonth();
            tasksData.splice(_daysInThisMonth);

            setTasksData(
                tasksData.map((task) => {
                    if (task.id === 1) {
                        task.desable = false;
                        return task;
                    }
                    return task;

                })
            );

        }
    });

    useEffect(() => {
        if (window.wgcAuthInitPromise) {
            window.wgcAuthInitPromise
                .done(function () {
                    getEntitlements();
                });
        } else {
            getEntitlements();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : ((r & 0x3) | 0x8);
            return v.toString(16);
        });
    }

    const startTask = (item) => {
        axios.post(PURCHASE_PRODUCT_VC,
            {
                "product_code": item.productCode,
                "language": "ru",
                "transaction_id": uuidv4(),
                "expected_prices": [{"code":"gold","amount":"0","item_type":"currency"}]
            }, {
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then(() => {

                setTasksData(
                    tasksData.map((task) => {
                        if (task.id === item.id) {
                            task.completed = true;
                            return task;
                        }
                        return task;

                    })
                );

                setItem(item)
                setOpenPopup(true)

            });
    }

    return (
        <>

            <div className='c_items-wrap'>
                <Help />
                <div className='c_items__bg'>
                    <img className='pc' alt="" src="https://tanki-media-content.tanki.su/tanki-media/daily-check-in/images/06-03-24/pc.png" />
                    <img className='mob' alt="" src="https://tanki-media-content.tanki.su/tanki-media/daily-check-in/images/06-03-24/mob.png" />
                </div>
                <div className='c_items'>
                    {tasksData.map((item) =>
                        <div
                            key={item.id}
                            onClick={(e) => {
                                if (isAuth) {
                                    if (!item.desable && !item.completed) {
                                        startTask(item)
                                    }
                                } else {
                                    setOpenPopup(true)
                                }

                            }}

                            className={item.completed ? "c_item c_comlete" :
                                `${item.desable && !item.completed ? "c_item c_desable" : "c_item c_default"}`}
                        >
                            <div className='c_item__bg'>
                                <img alt="" src={item.bg} />
                            </div>

                            <div
                                className={"c_item__body"}
                            >
                                <img
                                    className={"c_item__icon"}
                                    alt=""
                                    src={item.task.icon}
                                />
                                <span className={"c_item__text"}>

                                    {width > 720 ? (
                                        <>
                                            {parse(item.task.text)}
                                        </>
                                    ) : (
                                        <>
                                            {item.task.textMob}
                                        </>
                                    )}

                                </span>
                            </div>

                            {item.completed ? (
                                <>
                                    <div className='c_comlete__bg'>
                                        <img alt="" src="https://tanki-media-content.tanki.su/ptl/dailyRewards/img/comlete.png" />
                                    </div>
                                </>
                            ) : ("")}

                        </div>
                    )}
                </div>
            </div>



            <div className={openPopup ? "c_task__overlay c_task-active" : "c_task__overlay"}>
                <div className="c_task__overlay-bg" onClick={(e) => {
                    setOpenPopup(false)
                }}></div>
                <div className="c_task">
                    <>
                        {!isAuth ? (
                            <div className="c_task__body">
                                <div className='c_task__close' onClick={(e) => {
                                    setOpenPopup(false)
                                }}>
                                    <img alt="" src="https://tanki-media-content.tanki.su/ptl/dailyRewards/img/close.svg" />
                                </div>
                                <div className="c_task__content">
                                    <img className="c_task__img" alt="" src="https://tanki-media-content.tanki.su/ptl/dailyRewards/img/timur-2.png" />
                                    <div className="c_task__text">
                                        <div className='c_task__title'>ОШИБКА</div>
                                        <p>Нужна авторизация <br />
                                            Пожалуйста, зайдите на сайт игры, чтобы иметь возможность забирать награды из календаря.</p>
                                    </div>
                                    <div className="c_btn" onClick={
                                        (e) => {
                                            const nextUrl = document.getElementsByClassName('js-cm-login-link')[0];
                                            window.open(nextUrl.getAttribute('href'),"_self");
                                        }
                                    }>
                                        <img className="c_btn__img" alt="" src="https://tanki-media-content.tanki.su/ptl/dailyRewards/img/btn-color.png" />
                                        <div className="c_btn__text">
                                            ВОЙТИ
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="c_task__body c_task__comlete">
                                <div className='c_task__close' onClick={(e) => {
                                    setOpenPopup(false)
                                }}>
                                    <img alt="" src="https://tanki-media-content.tanki.su/ptl/dailyRewards/img/close.svg" />
                                </div>
                                <div className="c_task__content">
                                    <img className="c_task__img" alt="" src="https://tanki-media-content.tanki.su/ptl/dailyRewards/img/timur-1.png" />
                                    <div className="c_task__text">
                                        <div className='c_task__title'>ОТМЕТКА ГОТОВА</div>
                                        <div className='c_task__icon-wrap'>
                                            <img className="c_task__icon" alt="" src={item.task.icon} />

                                            {item.color === "black" ? (
                                                <img className="c_btn__icon-bg" alt="" src="https://tanki-media-content.tanki.su/ptl/dailyRewards/img/black.png" />
                                            ) : ("")}
                                            {item.color === "red" ? (
                                                <img className="c_btn__icon-bg" alt="" src="https://tanki-media-content.tanki.su/ptl/dailyRewards/img/red.png" />
                                            ) : ("")}

                                        </div>
                                        <div className='c_task__sub-title'>{parse(item.task.text)}</div>
                                        <p>* Награда может приходить с некоторой задержкой. Пожалуйста, не забудьте получить её в клиенте, иначе вы не сможете забирать награды в дальнейшем.</p>
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                </div>
            </div>



        </>
    );
};

export default Items;